import {createApp} from 'vue'
import StafetDonationStepVirksomhed from './StafetDonationStepVirksomhed'

const el = '.kb-component--stafet-donation-step-virksomhed'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((StafetDonationStepVirksomhedDOM)=>{
            const component = createApp(StafetDonationStepVirksomhed).use(Store)
            component.mount(StafetDonationStepVirksomhedDOM)
        })
    }
}